import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function WelcomePopup() {
  const [show, setShow] = useState(false);
  const [slide, setSlide] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("welcomePopupSeen")) return;
    const timer = setTimeout(() => setShow(true), 2500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!show) return;
    const autoSlide = setInterval(() => {
      setSlide(s => s === 0 ? 1 : 0);
    }, 3000);
    return () => clearInterval(autoSlide);
  }, [show]);

  function handleClose() {
    localStorage.setItem("welcomePopupSeen", "true");
    setShow(false);
  }

  function handleShopNow() {
    localStorage.setItem("welcomePopupSeen", "true");
    setShow(false);
    navigate("/products");
  }

  if (!show) return null;

  return (
    <div style={{
      position: "fixed", inset: 0, zIndex: 99999,
      background: "rgba(26,46,10,0.65)",
      backdropFilter: "blur(4px)",
      display: "flex", alignItems: "center", justifyContent: "center",
      padding: "20px",
    }}>
      <style>{`
        @keyframes popupRise { from { opacity:0; transform:translateY(30px) scale(0.96); } to { opacity:1; transform:translateY(0) scale(1); } }
        @keyframes slideIn { from { opacity:0; transform:translateX(40px); } to { opacity:1; transform:translateX(0); } }
        @keyframes logoFloat { 0%,100% { transform:translateY(0); } 50% { transform:translateY(-10px); } }
      `}</style>

      <div style={{
        background: "#fff", borderRadius: "24px", width: "100%", maxWidth: "400px",
        overflow: "hidden", boxShadow: "0 32px 80px rgba(0,0,0,0.3)",
        animation: "popupRise 0.4s cubic-bezier(0.22,1,0.36,1)", position: "relative",
      }}>
        {/* Close button */}
        <button onClick={handleClose} style={{
          position: "absolute", top: 14, right: 14, zIndex: 10,
          background: "rgba(255,255,255,0.2)", border: "none", color: "#F7F0E3",
          fontSize: "1rem", cursor: "pointer", width: 28, height: 28,
          borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center",
        }}>✕</button>

        {/* Slide 1 — WELCOME149 */}
        {slide === 0 && (
          <div key="slide0" style={{ animation: "slideIn 0.3s ease" }}>
            {/* Visual header */}
            <div style={{
              background: "linear-gradient(135deg, #1a3a0a 0%, #2D5016 100%)",
              padding: "48px 32px 36px",
              textAlign: "center", position: "relative", overflow: "hidden",
            }}>
              <div style={{
                position: "absolute", top: -40, left: -40, width: 160, height: 160,
                borderRadius: "50%", background: "radial-gradient(circle, rgba(200,134,10,0.25) 0%, transparent 70%)",
              }} />
              <div style={{
                position: "absolute", bottom: -30, right: -30, width: 120, height: 120,
                borderRadius: "50%", background: "radial-gradient(circle, rgba(200,134,10,0.2) 0%, transparent 70%)",
              }} />
              <div style={{ position: "relative", zIndex: 1 }}>
                <img src="/logo-white.png" alt="PureJar" style={{ width: 64, height: 64, borderRadius: 12, marginBottom: 16, objectFit: "contain", animation: "logoFloat 3s ease-in-out infinite" }} />
                <div style={{
                  fontSize: "4.5rem", fontFamily: "'Playfair Display', serif",
                  fontWeight: 700, color: "#C8860A", lineHeight: 1,
                }}>₹149</div>
                <p style={{ color: "rgba(247,240,227,0.8)", fontSize: "0.88rem", marginTop: 8 }}>
                  Your first salt, at a mountain price
                </p>
              </div>
            </div>

            {/* Content */}
            <div style={{ padding: "24px 28px 28px", textAlign: "center" }}>
              <span style={{
                background: "#C8860A", color: "#fff", fontSize: "0.65rem",
                fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase",
                padding: "4px 14px", borderRadius: "100px", display: "inline-block", marginBottom: 14,
              }}>First Purchase Only</span>
              <h2 style={{
                fontFamily: "'Playfair Display', serif", color: "#1A2E0A",
                fontSize: "1.6rem", margin: "0 0 10px",
              }}>Get any salt for ₹149</h2>
              <p style={{ color: "#6B7C5A", fontSize: "0.84rem", lineHeight: 1.6, marginBottom: 20 }}>
                Hara Namak · Hemp Salt · Flax Salt · Turmeric<br />
                Use code <strong style={{ color: "#C8860A" }}>WELCOME149</strong> at checkout
              </p>
              <button onClick={handleShopNow} style={{
                width: "100%", padding: "15px", background: "#2D5016", color: "#F7F0E3",
                border: "none", borderRadius: "12px", fontSize: "0.88rem", fontWeight: 700,
                letterSpacing: "0.08em", textTransform: "uppercase", cursor: "pointer",
                fontFamily: "'Inter', sans-serif", marginBottom: 10,
              }}>Shop Now →</button>
              <button onClick={handleClose} style={{
                display: "block", width: "100%", background: "none", border: "none",
                color: "#9A8B7A", fontSize: "0.82rem", cursor: "pointer", fontFamily: "'Inter', sans-serif",
              }}>Maybe later</button>
            </div>
          </div>
        )}

        {/* Slide 2 — Bundle Deal */}
        {slide === 1 && (
          <div key="slide1" style={{ animation: "slideIn 0.3s ease" }}>
            {/* Visual header */}
            <div style={{
              background: "linear-gradient(135deg, #C8860A 0%, #E09A20 100%)",
              padding: "48px 32px 36px",
              textAlign: "center", position: "relative", overflow: "hidden",
            }}>
              <div style={{
                position: "absolute", top: -40, left: -40, width: 160, height: 160,
                borderRadius: "50%", background: "radial-gradient(circle, rgba(255,255,255,0.2) 0%, transparent 70%)",
              }} />
              <div style={{
                position: "absolute", bottom: -30, right: -30, width: 120, height: 120,
                borderRadius: "50%", background: "radial-gradient(circle, rgba(255,255,255,0.15) 0%, transparent 70%)",
              }} />
              <div style={{ position: "relative", zIndex: 1 }}>
                <img src="/logo-white.png" alt="PureJar" style={{ width: 64, height: 64, borderRadius: 12, marginBottom: 16, objectFit: "contain", animation: "logoFloat 3s ease-in-out infinite" }} />
                <div style={{
                  fontSize: "4.5rem", fontFamily: "'Playfair Display', serif",
                  fontWeight: 700, color: "#fff", lineHeight: 1,
                }}>10% Off</div>
                <p style={{ color: "rgba(255,255,255,0.85)", fontSize: "0.88rem", marginTop: 8 }}>
                  When you buy 2 or more
                </p>
              </div>
            </div>

            {/* Content */}
            <div style={{ padding: "24px 28px 28px", textAlign: "center" }}>
              <span style={{
                background: "#2D5016", color: "#F7F0E3", fontSize: "0.65rem",
                fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase",
                padding: "4px 14px", borderRadius: "100px", display: "inline-block", marginBottom: 14,
              }}>Bundle Deal</span>
              <h2 style={{
                fontFamily: "'Playfair Display', serif", color: "#1A2E0A",
                fontSize: "1.6rem", margin: "0 0 10px",
              }}>Buy 2, Get 10% Off</h2>
              <p style={{ color: "#6B7C5A", fontSize: "0.84rem", lineHeight: 1.6, marginBottom: 20 }}>
                Mix & match any salts or turmeric<br />
                Discount applied <strong style={{ color: "#2D5016" }}>automatically</strong> at checkout
              </p>
              <button onClick={handleShopNow} style={{
                width: "100%", padding: "15px", background: "#C8860A", color: "#fff",
                border: "none", borderRadius: "12px", fontSize: "0.88rem", fontWeight: 700,
                letterSpacing: "0.08em", textTransform: "uppercase", cursor: "pointer",
                fontFamily: "'Inter', sans-serif", marginBottom: 10,
              }}>Shop the Offer →</button>
              <button onClick={handleClose} style={{
                display: "block", width: "100%", background: "none", border: "none",
                color: "#9A8B7A", fontSize: "0.82rem", cursor: "pointer", fontFamily: "'Inter', sans-serif",
              }}>Maybe later</button>
            </div>
          </div>
        )}

        {/* Slide dots + arrows */}
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "center",
          gap: 16, paddingBottom: 20,
        }}>
          <button onClick={() => setSlide(0)} style={{
            background: "none", border: "none", cursor: "pointer", padding: 4,
            color: slide === 0 ? "#2D5016" : "#C8DCC6", fontSize: "1.2rem",
          }}>‹</button>
          <div style={{ display: "flex", gap: 6 }}>
            <div onClick={() => setSlide(0)} style={{
              width: slide === 0 ? 20 : 8, height: 8, borderRadius: 100,
              background: slide === 0 ? "#2D5016" : "#C8DCC6",
              cursor: "pointer", transition: "all 0.3s ease",
            }} />
            <div onClick={() => setSlide(1)} style={{
              width: slide === 1 ? 20 : 8, height: 8, borderRadius: 100,
              background: slide === 1 ? "#C8860A" : "#C8DCC6",
              cursor: "pointer", transition: "all 0.3s ease",
            }} />
          </div>
          <button onClick={() => setSlide(1)} style={{
            background: "none", border: "none", cursor: "pointer", padding: 4,
            color: slide === 1 ? "#C8860A" : "#C8DCC6", fontSize: "1.2rem",
          }}>›</button>
        </div>
      </div>
    </div>
  );
}